export class ContextPublicRequest {
    FrontendUrl: string;
    Wholesaler: number;

    constructor(frontendUrl: string, wholesaler: number) {
        this.FrontendUrl = frontendUrl;
        this.Wholesaler = wholesaler;
    }
}
